import { NSALayout, NSALayoutCustomProps } from "namirasoft-account-react";
import { Component } from "react";
import { ErpRouterProps } from "./ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "./ErpScope";
import { ErpScopeView } from "./components/ErpScopeView";

export type ErpLayoutProps<RowType extends { id: string }, RowTypeInput = RowType> =
    NSALayoutCustomProps<RowType, RowTypeInput> & Partial<ErpRouterProps> & {
        mode: ErpScopeMode;
        fields?: ErpScopeField[];
    };

const ALL_FIELDS: ErpScopeField[] = [ErpScopeField.Company, ErpScopeField.Branch, ErpScopeField.FiscalYear];

interface ErpLayoutState
{
    scopeVersion: number;
}

export class ErpLayout<RowType extends { id: string } = any, RowTypeInput = RowType> extends Component<ErpLayoutProps<RowType, RowTypeInput>, ErpLayoutState>
{
    private unsubscribeScope: (() => void) | null = null;
    private lastCompanyId: string | null = null;
    private lastBranchId: string | null = null;
    private lastFiscalYearId: string | null = null;

    override state: ErpLayoutState = { scopeVersion: 0 };

    override componentDidMount(): void
    {
        this.lastCompanyId = ErpScope.getCompanyIdRaw();
        this.lastBranchId = ErpScope.getBranchIdRaw();
        this.lastFiscalYearId = ErpScope.getFiscalYearIdRaw();
        this.unsubscribeScope = ErpScope.subscribe(() =>
        {
            let companyId = ErpScope.getCompanyIdRaw();
            let branchId = ErpScope.getBranchIdRaw();
            let fiscalYearId = ErpScope.getFiscalYearIdRaw();
            let changed = companyId !== this.lastCompanyId
                || branchId !== this.lastBranchId
                || fiscalYearId !== this.lastFiscalYearId;
            if (!changed)
                return;
            this.lastCompanyId = companyId;
            this.lastBranchId = branchId;
            this.lastFiscalYearId = fiscalYearId;
            if (this.props.mode !== ErpScopeMode.Filter)
                return;
            this.setState(s => ({ scopeVersion: s.scopeVersion + 1 }));
        });
    }

    override componentWillUnmount(): void
    {
        this.unsubscribeScope?.();
    }

    override render()
    {
        let { mode: scopeMode, fields, ...layoutProps } = this.props;
        ErpScope.setMode(scopeMode);
        let effectiveFields = fields ?? ALL_FIELDS;
        let scope = this.props.servers && scopeMode !== ErpScopeMode.None && effectiveFields.length > 0
            ? <ErpScopeView {...this.props} servers={this.props.servers} mode={scopeMode} fields={effectiveFields} />
            : <></>;

        return (
            <NSALayout
                key={this.state.scopeVersion}
                {...layoutProps}
                master_menu={true}
                header={{ mega_menu: true }}
                action={{ ...this.props.action, children: scope }}
            >
                {this.props.children}
            </NSALayout>
        );
    }
}